import {
    /** FETCH APPLICATION  */
    FETCH_ASSIGNAPPLICATION_FULFILLED,
    FETCH_ASSIGNAPPLICATION_REJECTED,
    FETCH_ASSIGNAPPLICATION_PENDING,
    RESET,
} from "../../actions/application/assignApplications";
const initialState = {
    done: false,
    error: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ASSIGNAPPLICATION_PENDING:
            return {
                done: false,
                error: false,
            };
        case FETCH_ASSIGNAPPLICATION_FULFILLED:
            return {
                ...state,
                assignApplication: action.payload,
                done: true,
                error: false
            };
        case FETCH_ASSIGNAPPLICATION_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
            };
        case RESET:
            return {
                initialState,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};